import React from 'react';
import NewsCard from './NewsCard';
import Icon from '../../../components/AppIcon';

const NewsGrid = ({ articles, expandedArticles, onExpandArticle, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(6)]?.map((_, index) => (
          <div key={index} className="bg-card border border-border rounded-lg shadow-government animate-pulse">
            <div className="h-48 bg-muted rounded-t-lg" />
            <div className="p-6">
              <div className="flex items-center space-x-2 mb-3">
                <div className="h-6 w-16 bg-muted rounded-full" />
                <div className="h-4 w-20 bg-muted rounded" />
              </div>
              <div className="h-6 bg-muted rounded mb-3" />
              <div className="space-y-2 mb-4">
                <div className="h-4 bg-muted rounded" />
                <div className="h-4 bg-muted rounded w-3/4" />
              </div>
              <div className="flex justify-between">
                <div className="h-8 w-24 bg-muted rounded" />
                <div className="flex space-x-2">
                  <div className="h-8 w-8 bg-muted rounded" />
                  <div className="h-8 w-8 bg-muted rounded" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (articles?.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="w-24 h-24 mx-auto mb-4 bg-muted rounded-full flex items-center justify-center">
          <Icon name="FileText" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">
          ไม่พบข่าวสารที่ค้นหา
        </h3>
        <p className="text-muted-foreground mb-6">
          ลองปรับเปลี่ยนคำค้นหาหรือตัวกรองเพื่อดูข่าวสารอื่น
        </p>
        <button
          onClick={() => window.location?.reload()}
          className="inline-flex items-center space-x-2 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-government"
        >
          <Icon name="RotateCcw" size={16} />
          <span>รีเฟรชหน้า</span>
        </button>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {articles?.map((article) => (
        <NewsCard
          key={article?.id}
          article={article}
          isExpanded={expandedArticles?.includes(article?.id)}
          onExpand={onExpandArticle}
        />
      ))}
    </div>
  );
};

export default NewsGrid;